import queryS3DownloadUrl from "services/queryS3DownloadUrl";

export const appointmentHasRecordingInProgress = (
  appointment: AppointmentMetaData,
) => {
  return (
    !appointment.session_recording_upload_metadata?.finished &&
    !!appointment.session_recording_upload_metadata?.uploadId
  );
};

const checkAudioFileExists = (url: string) =>
  new Promise((resolve) => {
    const audio = new Audio();
    audio.preload = "metadata";
    audio.src = url;
    audio.addEventListener("canplay", () => resolve(true), {
      once: true,
    });
    audio.addEventListener("error", () => resolve(false), { once: true });
  });

export const checkAppointmentRecordingExists = async (
  appointmentId: string,
) => {
  try {
    const downloadUrl = await queryS3DownloadUrl(appointmentId);
    if (!downloadUrl) {
      return false;
    }
    return await checkAudioFileExists(downloadUrl);
  } catch (error) {
    return false;
  }
};
